import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface DecisionsToImposeFineServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<DecisionsToImposeFineServiceData>(
    db,
    'decisionsToImposeFineService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
